import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { restoreAuthFromToken } from '../store/authActions';

const PrivateRoute = ({ children }) => {
  const dispatch = useDispatch();
  const { isAuthenticated, isLoading } = useSelector((state) => state.auth);
  const location = useLocation();
  const [hasTriedRestore, setHasTriedRestore] = useState(false);

  useEffect(() => {
    // Try to restore authentication on mount
    if (!isAuthenticated && !hasTriedRestore) {
      setHasTriedRestore(true);
      dispatch(restoreAuthFromToken());
    }
  }, [dispatch, isAuthenticated, hasTriedRestore]);

  // Show loading while trying to restore auth
  if (isLoading || (!isAuthenticated && !hasTriedRestore)) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          fontSize: '18px',
          color: '#666',
        }}
      >
        Loading...
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

PrivateRoute.propTypes = {
  children: PropTypes.node.isRequired,
};

export default PrivateRoute;
